import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { render, css } from '@onviobr/element';
export var shadowDOMPolyfillContainingBlockFix = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t:host {\n\t\t/**\n\t* This is because Firefox doesn't support shadowDOM\n\t* and the position fixed is the viewport and not the shadow root.\n\t* With this hack we make the browser to use the\n\t* host element as containing block\n\t*/\n\t\t-moz-filter: blur(0px);\n\t\t/**\n\t* This is because Safari doesn't work correctly with shadowDOM\n\t* and the position fixed is the viewport and not the shadow root.\n\t* With this hack we make the browser to use the\n\t* host element as containing block\n\t*/\n\t\ttransform: scaleX(1);\n\t}\n\n\t/**\n\t* This is because IE does not honor the containing block rules regarding\n\t* position: fixed with a parent with filter or transform\n\t* With this only on IE it will fallback to position absolute and will\n\t* need a parent with position: relative\n\t*/\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\t:host {\n\t\t\tposition: relative !important;\n\t\t}\n\t}\n"])));
export var shadowDOMPolyfillContainingBlockFixChild = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t/**\n\t* This is because IE does not honor the containing block rules regarding\n\t* position: fixed with a parent with filter or transform\n\t* With this only on IE it will fallback to position absolute and will\n\t* need a parent with position: relative\n\t* TODO: Remove when IE 11 is gone\n\t*/\n\t@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n\t\t:host {\n\t\t\tposition: absolute !important;\n\t\t}\n\t}\n"])));
export var safariForceRepaint = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t/**\n\t* This is a hack for safari only to force reflow on a fixed positioned element\n\t* inside a shadow dom. Should be removed when safari fix this issue.\n\t*/\n\t@keyframes repaint {\n\t\t0% {\n\t\t\tbox-shadow: 1px 1px 1px transparent;\n\t\t}\n\t\t100% {\n\t\t\tbox-shadow: 0px 0px 0px transparent;\n\t\t}\n\t}\n\t@media not all and (min-resolution: 0.001dpcm) {\n\t\t@media {\n\t\t\t:host {\n\t\t\t\tanimation-name: repaint;\n\t\t\t\tanimation-duration: 1ms;\n\t\t\t\tanimation-iteration-count: infinite;\n\t\t\t}\n\t\t}\n\t}\n"])));
export var renderStyleGlobally = function renderStyleGlobally(style, name) {
  if (!document || !document.head) {
    return;
  }
  var prev = document.head.querySelector("style[data-component=\"".concat(name, "\"]"));
  if (prev) {
    return;
  }
  var container = document.createElement('div');
  render(style, container);
  if (container.firstElementChild) {
    container.firstElementChild.setAttribute('data-component', name);
    var append = document.head.append || document.head.appendChild;
    append.call(document.head, container.firstElementChild);
  }
};
export var renderStyleCssGlobally = function renderStyleCssGlobally(style, name) {
  var supportsAdoptingStyleSheets = document.adoptedStyleSheets && 'replace' in CSSStyleSheet.prototype;
  if (!document || !document.head) {
    return;
  }
  if (supportsAdoptingStyleSheets) {
    var styleSheet = style.styleSheet;
    document.adoptedStyleSheets = [].concat(_toConsumableArray(document.adoptedStyleSheets.filter(function (s) {
      return s !== styleSheet;
    })), [styleSheet]);
  } else {
    var prev = document.head.querySelector("style[data-component=\"".concat(name, "\"]"));
    if (prev) {
      return;
    }
    var container = document.createElement('style');
    container.innerHTML = style.cssText;
    container.setAttribute('data-component', name);
    var append = document.head.append || document.head.appendChild;
    append.call(document.head, container);
  }
};
export var jsonParseWithFieldNameMap = function jsonParseWithFieldNameMap(json, map) {
  var result = JSON.parse(json, function (key, value) {
    if (map[key]) {
      var path = map[key].split('.');
      var currentTarget = this;
      for (var i = 0; i < path.length - 1; i++) {
        var propName = path[i];
        currentTarget = currentTarget[propName] || (currentTarget[propName] = {});
      }
      currentTarget[path[path.length - 1]] = value;
    } else return value;
  });
  return result;
};
